import { Component } from '@angular/core';
import { CardTableCustomCellBaseComponent } from '@shared/modules/card-table/components/custom-cells/card-table-custom-cell-base/card-table-custom-cell-base.component';

@Component({
  selector: 'app-role-value-cell',
  templateUrl: './role-value-cell.component.html',
  styleUrls: ['./role-value-cell.component.scss'],
})
export class RoleValueCellComponent extends CardTableCustomCellBaseComponent {}
